import { createSlice } from '@reduxjs/toolkit';
export const newAddedPersistedRows = createSlice({
  name: 'newAddedPersistedRows',
  initialState: {
    classRows: []
  },
  reducers: {
    setClassRows: (state, action) => {
      return action.payload;
    }
  },
  extraReducers: {
    // Extra reducer comes here
  }
});

export const { setClassRows } = newAddedPersistedRows.actions;
